import CarouselCard from 'components/OfferList/OfferCards/CarouselCard'
import { showUserReviewsRating } from 'lib/order/reviewUtils'
import React, { useMemo } from 'react'
import OfferLabels from 'components/Common/Labels/OfferLabels'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import OfferBadgeTag from 'components/Common/OfferBadgeTag'
import LEOfferPriceDetails from './LEOfferPriceDetails'
import ProductPaletteProvider, { ProductPalette } from 'contexts/ProductPaletteContext'
import { isUltraLuxOffer } from 'lib/offer/offerUtils'
import { isLuxuryPlusEnabled } from 'loyalty/selectors/featureToggle'
import LuxPlusHiddenOfferCarouselCard from 'loyalty/components/HiddenOffer/LuxPlusHiddenOfferCarouselCard'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import { isLuxPlusHiddenOffer } from 'loyalty/selectors/luxPlusHiddenOffer'

interface MappedProps {
  isLuxPlusEnabled: boolean;
  isLuxPlusHiddenOffer: boolean;
}

interface Props extends MappedProps {
  offer: App.Offer | App.OfferSummary
  onClick: () => void
  className?: string;
  offerUrl: string;
}

function LEOfferCard(props: Props) {
  const { offer, onClick, className, offerUrl, isLuxPlusHiddenOffer, isLuxPlusEnabled } = props
  const { lowestPricePackage } = offer

  const reviews = useMemo(() => ({
    showReviews: showUserReviewsRating(offer.property?.rating, offer.property?.reviewsTotal),
    rating: offer.property?.rating,
    reviewsTotal: offer.property?.reviewsTotal,
    ratingSubtitle: offer.property?.reviewsSource === 'google' ? 'From online reviews' : undefined,
  }), [offer.property])

  const paletteValue: ProductPalette = isLuxPlusEnabled && !!offer.loyalty?.access ? 'loyalty' : isUltraLuxOffer(offer) ? 'ultralux' : 'default'

  const memberPrice = lowestPricePackage?.memberPrice ?? 0
  const showMemberPrice = isLuxPlusEnabled && memberPrice > 0
  const saveAmount = showMemberPrice ? (lowestPricePackage?.price ?? 0) - memberPrice : undefined

  return (
    <ProductPaletteProvider palette={paletteValue}>
      {isLuxPlusHiddenOffer && <LuxPlusHiddenOfferCarouselCard offer={offer} />}
      {!isLuxPlusHiddenOffer && <CarouselCard
        data-testid="offer-card"
        className={className}
        bookmarkButton={<BookmarkButton offer={offer} />}
        description={offer.name}
        image={offer.image}
        location={[offer.locationHeading, offer.locationSubheading].filter((t) => t).join(', ')}
        title={offer.property?.name ?? ''}
        offerPriceDetails={<LEOfferPriceDetails offer={offer}/>}
        offerUrl={offerUrl}
        productType={offer.productType}
        reviews={reviews}
        urgencyLabels={<Group direction="horizontal" gap={4} noDisplayWhenEmpty wrap="wrap">
          <OfferLabels offer={offer} saveAmount={saveAmount} showMemberInclusionLabels/>
          {offer.badge && <OfferBadgeTag badge={offer.badge} />}
        </Group>}
        onClick={onClick}
      />}
    </ProductPaletteProvider>
  )
}

const mapStateToProps = (state: App.State, ownProps: Partial<Props>): MappedProps => ({
  isLuxPlusEnabled: isLuxuryPlusEnabled(state),
  isLuxPlusHiddenOffer: isLuxPlusHiddenOffer(state, ownProps.offer),
})

export default connect(mapStateToProps)(LEOfferCard)
